import { benefits } from "@/mocks/homeData";

export default function BenefitsBar() {
  return (
    <section className="w-full bg-primary-950 py-10 md:py-12">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {benefits.map((item) => (
            <div key={item.title} className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-800 shrink-0">
                <i className={`${item.icon} text-accent-400 text-xl`} />
              </div>
              <div>
                <h3 className="font-heading text-sm font-semibold text-white mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-secondary-300 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}